// api.js
import axios from "axios";

export const api = axios.create({
  baseURL: "/api",
});

// sempre que houver token no localStorage, já coloca no header
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


// Interceptor para capturar 401
let isRedirecting = false;

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 && !isRedirecting) {
      isRedirecting = true;

      const message = error.response?.data?.error;

      if (message === "Token expirado") {
        alert("Sessão expirada. Faça login novamente.");
      } else {
        alert("Acesso não autorizado.");
      }

      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);